const URL = '  https://food-mafia-server.herokuapp.com/api/register';
const EXTURL = 'https://api.documenu.com/v2/restaurant/4072702673999819?key=eb12d93b695847acfe7f2ec50ca6813f';

export const addNewUser = (user) =>
    fetch(URL, {
        method: 'POST',
        body: JSON.stringify(user),
        headers: {
            'content-type': 'application/json'
        }
    }).then(response => response.json());

export const findAllUser = () =>
    fetch(URL)
        .then(res => res.json());

export default {
    addNewUser, findAllUser
}